import classNames from 'classnames'
import * as React from 'react'

import {getAgentHref} from '../../../../../routes'
import {getCanViewAgentDetails} from '../../../../../selectors'
import type {AgentPool} from '../../../../../services/rest'
import type {NormalizedAgent} from '../../../../../types'
import AgentLink from '../../../../common/AgentLink/AgentLink'

import AuthorizeAgent from './AuthorizeAgent/AuthorizeAgent'
import DisconnectionComment from './DisconnectionComment/DisconnectionComment'
import StatusComment from './StatusComment/StatusComment'

import styles from './AgentListView.css'

import {useAppSelector} from 'src/hooks/react-redux'

function UnauthorizedAgentListView({
  agent,
  className,
  isAgentLeft,
  authorizableInPools,
}: {
  agent: NormalizedAgent
  className?: string
  isAgentLeft?: boolean
  authorizableInPools?: ReadonlyArray<AgentPool>
}) {
  const {id, connected, name, pool, osType, authorized = false, ip, disconnectionComment} = agent
  const {comment: authorizedComment} = agent.authorizedInfo || {}

  return (
    <div data-test="agent" className={classNames(className, styles.agent)}>
      <AgentLink
        isSakuraUI
        name={name}
        className={styles.link}
        {...(useAppSelector(getCanViewAgentDetails)
          ? {
              href: getAgentHref(id),
              agentId: id,
              osType,
            }
          : {})}
      />
      {connected ? null : (
        <DisconnectionComment className={styles.disconnectionComment}>
          {disconnectionComment}
        </DisconnectionComment>
      )}
      {authorizedComment?.text != null ? (
        <StatusComment
          statusTitle="Unauthorized"
          text={authorizedComment.text}
          user={authorizedComment.user}
          timestamp={authorizedComment.timestamp}
          className={styles.statusComment}
        />
      ) : null}
      <div className={styles.split} />
      <div>{ip}</div>
      <div className={styles.authorize}>
        {isAgentLeft && authorizableInPools != null && authorizableInPools.length > 0 ? (
          <AuthorizeAgent
            id={id}
            name={name}
            poolId={pool.id}
            authorized={authorized}
            authorizableInPools={authorizableInPools}
            isAgentLeft
          />
        ) : null}
      </div>
    </div>
  )
}

export default UnauthorizedAgentListView
